/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImageResponse } from '../../models/image-response';

export interface CreateImageToEntity$Params {
      body?: {

/**
 * Image file resource
 */
'file': Blob;
'imageCreateRequest': Blob;
}
}

export function createImageToEntity(http: HttpClient, rootUrl: string, params?: CreateImageToEntity$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageResponse>> {
  const rb = new RequestBuilder(rootUrl, createImageToEntity.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImageResponse>;
    })
  );
}

createImageToEntity.PATH = '/images';
